import React, { useState } from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../../firebase/firebase';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const contactMe = async (e) => {
    e.preventDefault();
    const colRef = collection(db, 'contacts');
    await addDoc(colRef, {
      name, email, subject, message,
    })
      .then(() => {
        setSuccess(true);
      })
      .catch((err) => {
        setSuccess(false);
        alert(err.message);
      });

    setName('');
    setEmail('');
    setSubject('');
    setMessage('');
  };

  return (
    <Box
      id="contact"
      sx={{
        width: '90%', bgcolor: 'transparent', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', margin: '70px auto',
      }}
    >
      <Box sx={{ width: { xs: '80%', sm: '41%' } }}>
        <Typography sx={{
          background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: { xs: '35px', sm: '50px' }, fontWeight: '600', lineHeight: { xs: '40px', sm: '70px' },
        }}
        >
          We Would love To Hear From You
        </Typography>
        <Typography sx={{
          color: '#71E5FF', lineHeight: 'auto', padding: '20px 0', fontSize: '12',
        }}
        >
          Our team will respond within 24hrs
        </Typography>
      </Box>
      <Box sx={{ width: { xs: '100%', sm: '58%' } }}>
        <form
          onSubmit={contactMe}
          style={{
            width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '10px',
          }}
        >
          <input
            onChange={(e) => setName(e.target.value)}
            value={name}
            style={{
              width: '80%', padding: '15px', border: '2px solid #F49867', color: '#AE67FA', borderRadius: '5px', outline: 'none', background: 'transparent',
            }}
            type="text"
            placeholder="Your Name"
          />
          <input
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            style={{
              width: '80%', padding: '15px', border: '2px solid #F49867', color: '#AE67FA', borderRadius: '5px', outline: 'none', background: 'transparent',
            }}
            type="email"
            placeholder="Your Email"
          />
          <input
            onChange={(e) => setSubject(e.target.value)}
            value={subject}
            style={{
              width: '80%', padding: '15px', border: '2px solid #F49867', color: '#AE67FA', borderRadius: '5px', outline: 'none', background: 'transparent',
            }}
            type="text"
            placeholder="Subject"
          />
          <textarea
            onChange={(e) => setMessage(e.target.value)}
            value={message}
            style={{
              width: '80%', padding: '15px', border: '2px solid #F49867', color: '#AE67FA', borderRadius: '5px', outline: 'none', background: 'transparent',
            }}
            rows="5"
            cols="15"
            placeholder="Your message here..."
          />
          <button
            style={{
              background: 'linear-gradient(to right, #AE67FA, #F49867)', cursor: 'pointer', color: '#fff', outline: 'none', borderRadius: '5px', width: '80%', padding: '12px', border: 'none', fontWeight: '400',
            }}
            type="submit"
          >
            Send Message
          </button>
        </form>
        {success && <Alert sx={{ width: '60%', margin: '20px auto' }} severity="success">We have recieved your message, thank you! We will reach out within 24hrs</Alert>}
      </Box>
    </Box>
  );
};

export default Contact;
